import apiClient from "./apiService";
import {parseFiltersToQueryString} from "../utils/parseFiltersToQueryString";

class StatisticsService {
    constructor() {
        if (StatisticsService.instance) {
            return StatisticsService.instance;
        }
        StatisticsService.instance = this;
    }

    async getStatistics(entityId = null, district = null, sectionId = null, page = 1, pageSize = 10) {
        try {
            let url = `/statistics?page=${page}&size=${pageSize}`;
            if (entityId) url += `&entityId=${entityId}`;
            if (district && typeof district === 'object') {
                if (district.districtId) url += `&districtId=${district.districtId}`;
                if (district.districtLocal) url += `&districtLocal=${district.districtLocal}`;
            }
            if (sectionId) url += `&sectionId[in]=${sectionId}`;

            return await apiClient.get(url);
        } catch (error) {
            console.error("Error fetching statistics:", error);
            throw error;
        }
    }

    async getStatisticsByUser() {
        try {
            let url = `/statistics-by-user`;
            return await apiClient.get(url);
        } catch (error) {
            console.error("Error fetching statistics:", error);
            throw error;
        }
    }

    async getDistrictsByEntity(entityId) {
        try {
            let url = `/goal-locations/districts/${entityId}`;
            return await apiClient.get(url);
        } catch (error) {
            console.error("Error fetching districts:", error);
            throw error;
        }
    }

    async getSections(filters = {}) {
        try {
            const queryString = parseFiltersToQueryString(filters);
            let url = `/goal-locations/sections${queryString ? `?${queryString}` : ""}`;

            return await apiClient.get(url);
        } catch (error) {
            console.error("Error fetching sections:", error);
            throw error;
        }
    }


    static getInstance() {
        if (!StatisticsService.instance) {
            StatisticsService.instance = new StatisticsService();
        }
        return StatisticsService.instance;
    }
}

export default StatisticsService.getInstance();
